export function partnerLinks() {
    $(document).on("click", ".partner-links-toggle", function () {
        $(this).toggleClass("active");
        $(".partner-links").stop().slideToggle();
    });
    $(document).on("click", ".partner-links-item", function () {
        $(this).addClass("active").siblings().removeClass("active");
        if( $(window).outerWidth(true) < 1200 ){
            $(".partner-links-toggle").removeClass("active");
            $(".partner-links").slideUp();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/partner-links.js